import React, {useState, useEffect, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {yesNoItem} from '../../../App';
import SubMenuView from '../../views/subMenuView';
import FDTN from './fdTN';
import {useMenu} from '../../../hooks/useMenu';
import Summary from './summary';
import SaveConfiguration from './save-config';
import SensorParameters from './sensor';
import CommandsContext from '../../../context/commandsContext';

function ConfigurationSummary() {
  const yesNoItem = [
    {id: 1, name: 'Yes', component: <Summary />},
    {id: 2, name: 'No', component: <SaveConfiguration />},
  ];

  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands}));
  }, []);

  // useEffect(() => {
  //   if (!leftPress) return;

  //   onComponent(<SensorParameters />);
  // }, [leftPress]);

  return (
    <SubMenuView
      title="Configuration Summary"
      menuItems={yesNoItem}
      content="Do you want to review the configuration?"
      isMenuDisabled
      onLeftCallback={() => onComponent(<SensorParameters />)}
    />
  );
}
export default ConfigurationSummary;
